import { render, staticRenderFns } from "./SlideComponent.vue?vue&type=template&id=4ac98b61&scoped=true"
import script from "./SlideComponent.vue?vue&type=script&lang=js"
export * from "./SlideComponent.vue?vue&type=script&lang=js"
import style0 from "./SlideComponent.vue?vue&type=style&index=0&id=4ac98b61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac98b61",
  null
  
)

export default component.exports